<template>
  <div class="home" @scroll="handleScroll($event)" id="home">
    <Carousel id="Carousel" @transmit="getIndex" />
    <ProductArea id="ProductArea" ref="ProductArea" :offsetTop="offsetTopArr[0]" />
    <TechnicalSupport id="TechnicalSupport" ref="TechnicalSupport" :offsetTop="offsetTopArr[1]" />
    <NewsCenter id="NewsCenter" ref="NewsCenter" :offsetTop="offsetTopArr[2]" />
    <JoinWR id="JoinWR" ref="JoinWR" :offsetTop="offsetTopArr[3]" />
    <MarketCooperation id="MarketCooperation" ref="MarketCooperation" :offsetTop="offsetTopArr[4]" />
    <AboutWR id="AboutWR" ref="AboutWR" :offsetTop="offsetTopArr[5]" />
    <div class="floating-frame">
      <el-popover placement="top-start" width="200" trigger="hover">
        <div>
          {{ '电话：' + contactInfo.telephone }}
        </div>
        <div>
          {{ ' 邮箱：' + contactInfo.email }}
        </div>
        <img loading="lazy" slot="reference" class="home-phone" src="@/assets/img/home/phone.png" alt="">
      </el-popover>
      <el-popover placement="top-start" width="100" trigger="hover">
        <img loading="lazy" class="home-wechat" src="@/assets/img/QRCode.png" alt="">
        <img loading="lazy" slot="reference" class="home-wechat" src="@/assets/img/home/wechat.png" alt="">
      </el-popover>
    </div>
    <Anchor container="#home" :scroll-offset="0" :bounds="600">
      <AnchorLink href="#Carousel" :title="firstTitle" />
      <AnchorLink href="#ProductArea" title="领域&产品" />
      <AnchorLink href="#TechnicalSupport" title="技术支持" />
      <AnchorLink href="#NewsCenter" title="新闻中心" />
      <AnchorLink href="#JoinWR" title="加入我们" />
      <AnchorLink href="#MarketCooperation" title="市场合作" />
      <AnchorLink href="#AboutWR" title="关于我们" />
    </Anchor>
    <Footer />
  </div>
</template>


<script>

import Footer from '@/components/footer/index'
import Carousel from './components/carousel'
import ProductArea from './components/productArea'
import TechnicalSupport from './components/technicalSupport'
import NewsCenter from './components/newsCenter'
import JoinWR from './components/joinWR'
import MarketCooperation from './components/marketCooperation'
import AboutWR from './components/aboutWR'
export default {
  name: '',
  components: {
    Footer,
    Carousel,
    ProductArea,
    TechnicalSupport,
    NewsCenter,
    JoinWR,
    AboutWR,
    MarketCooperation
  },
  props: [],
  data() {
    return {
      contactInfo: {
        email: "hr@mrpower.cn",
        telephone: "0571-56761688",
        scrollTopNum: "",//页面滚动的高度
        tabshow: false,//是否进行某种操作,
      },
      titleAnimateFlag: '',
      scrollTop: 0,
      offsetTopArr: [0, 0, 0, 0, 0, 0],
      firstTitle: '用心沟通，用电相连',
    }
  },
  created() {
  },
  methods: {
    getContactInfo() {
      this.$apis.home_contact_information().then(res => {
        this.contactInfo = res.data.telephone
      })
    },
    getIndex(index) {
      switch (index) {
        case 0:
          this.firstTitle = '用心沟通，用电相连'
          break;
        case 1:
          this.firstTitle = '求是 创新 团结 合作'
          break;
        case 2:
          this.firstTitle = '电网优化领导者'
          break;
      }
    },
    handleScroll(e) {
      this.$set(this.offsetTopArr, 0, this.$refs.ProductArea.$refs.homeProductArea.getBoundingClientRect().top)
      this.$set(this.offsetTopArr, 1, this.$refs.TechnicalSupport.$refs.homeTechnicalSupport.getBoundingClientRect().top)
      this.$set(this.offsetTopArr, 2, this.$refs.NewsCenter.$refs.homeNewsCenter.getBoundingClientRect().top)
      this.$set(this.offsetTopArr, 3, this.$refs.JoinWR.$refs.homeJoinWR.getBoundingClientRect().top)
      this.$set(this.offsetTopArr, 4, this.$refs.MarketCooperation.$refs.homeMarketCooperation.getBoundingClientRect().top)
      this.$set(this.offsetTopArr, 5, this.$refs.AboutWR.$refs.homeAboutWR.getBoundingClientRect().top)
    },
  },
}
</script>

<style lang='scss' scoped>
.home {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;




  .floating-frame {
    position: fixed;
    left: 100px;
    bottom: 40px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 22px;
    z-index: 100;

  }


}
</style>
<style lang="scss">
.ivu-anchor-wrapper {
  position: fixed;
  z-index: 100;
  right: 100px !important;
  width: 170PX !important;
  bottom: 120px;
  text-align: right !important;
  font-size: 14PX;

  .ivu-anchor-link {
    line-height: 14PX;

    .ivu-anchor-link-title {
      color: #ffffff !important;
      opacity: 0.6;
    }

    .ivu-anchor-link-title:hover {
      color: #409EFF !important;
      opacity: 1;
      font-size: 16PX;
    }
  }

  .ivu-anchor-ink:before {
    display: none;
  }

  .ivu-anchor-link-active>.ivu-anchor-link-title {
    color: #409EFF !important;
    opacity: 1;
    font-size: 16PX;
  }
}
</style>